import React, { useState, useEffect, useRef } from "react";
import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import {
  Grid,
  Typography,
  TextField, 
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem, 
  Card,
  CardContent,
  FormHelperText
} from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';

import {
  DeleteOutline,
  FileCopy,
  ViewList,
} from "@mui/icons-material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fr, enGB } from "date-fns/locale";
import { DatePicker } from "@mui/x-date-pickers";




//react-tabulator
import 'react-tabulator/lib/styles.css'; // required styles
import 'react-tabulator/lib/css/tabulator.min.css'; // theme
import { ReactTabulator, reactFormatter } from 'react-tabulator';
import { cellFocusEditor, dateEditor } from "../../../services/Common";

import { useTranslation } from "react-i18next";
import AppointmentEntryLabTestModal from "../../../services/AppointmentEntryLabTestModal";
import LabTestAppointmentModal from "../../../services/LabTestAppointmentModal";
import LabTestResultModal from "../../../services/LabTestResultModal";
import PatientModal from "../../../services/PatientModal";

import { format, isValid } from 'date-fns';
let timeStamp = '';


//errorObject, addProductForm, formData, handleChange, handleCheck, handleReset, handleSubmit, handleUpdate, ManyTableData,ManyJsonSave,handleRDateChange,selectedDate,handleAdd,handleRefech,
const DispenserFormData = (props) => {
// console.log("props==",props);

  //get DispensingLanguage
const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
const lan = localStorage.getItem('LangCode');
const menukey = "test-appointment-entry";
const FacilityId=localStorage.getItem('FacilityId');

  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const { t, i18n } = useTranslation();
  const ReceiveDetailsRefHolder = useRef({ table: null });
  const ReceiveDetailsRef = ReceiveDetailsRefHolder.current;


  const [newBatchRowAdded, setNewBatchRowAdded] = useState(false);

  // console.log("Set r batch");
  
  const [open, setOpen] = useState(false); 
  const [openTestAppointment, setOpenTestAppointment] = useState(false); 
  const [openLabResult, setOpenLabResult] = useState(false);
  const [openContract, setContractOpen] = useState(false);

  // const [SoureOpen, setSoureOpen] = useState(false); 
  // const [DatePickerOpen, setDatePickerOpen] = useState(false); 

  const [manyTableData, setManyTableData] = useState([]);
  const [bStockUpdate, setbStockUpdate] = useState(false);
  

/*   let IssueToFacility = JSON.parse(localStorage.getItem("TestToFacility"));
  const IssueToList = IssueToFacility.hasOwnProperty(props.formData.ItemGroupId)?IssueToFacility[props.formData.ItemGroupId]:[];
 */
  const UsersListByFacility =JSON.parse(localStorage.getItem("UsersListByFacility"));
  const TestProfileGroup =JSON.parse(localStorage.getItem("TestProfileGroup"));
  const Gender = JSON.parse(localStorage.getItem("Gender"));
  const [currRowId, setCurrRowId] = useState(0);
  // const [currFormulation, setCurrFormulation] = useState("");
  // const [currExpiryDate, setCurrExpiryDate] = useState("");
  // const [bIsDisable, setbIsEnable] = useState(false);


  /* =====Start of Print Excel Many Code==== */
const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

const PrintMany = () => {
  
  let finalUrl = EXCEL_EXPORT_URL + "report/lab_test_appointment_invoice_entry_list_print.php";

  window.open(
    finalUrl +"?menukey=" +menukey
     + "&lan=" + localStorage.getItem("LangCode")
     +"&TransactionId=" + props.formData.TransactionId
     + "&FacilityId=" + FacilityId
     + "&TimeStamp=" + Date.now()
  );
};

const ExcelMany = () => {
  
  let finalUrl = EXCEL_EXPORT_URL + "report/lab_test_appointment_invoice_entry_list_excel.php";

  window.open(
    finalUrl +"?menukey=" +menukey
     + "&lan=" + localStorage.getItem("LangCode")
     +"&TransactionId=" + props.formData.TransactionId
     + "&FacilityId=" + FacilityId
     + "&TimeStamp=" + Date.now()
  );
};
/* =====End of Excel Export Code==== */
  
  
  const handleClose = (modalname) => {
    switch (modalname) {
      case "Products":
        setOpen(false);
        break;
      case "ProductsOpen":
        setOpen(true);
        break;

        case "TestAppointmentClose":
          setOpenTestAppointment(false);
          break;
        case "TestAppointmentOpen":
          setOpenTestAppointment(true);
          break;

      case "LabResultClose":
        setOpenLabResult(false);
        break;
      case "LabResultOpen":
        setOpenLabResult(true);
        break;

        case "Contract":
          setContractOpen(false);
          break;
  
        case "ContractOpen":
          setContractOpen(true);
          break;

      default:
        break;
    }
  }
  
  const addProduct = (NonOrderProductData) => {  
    /* console.log('Lot list from modal ', NonOrderProductData); */
 
    let temNonordata=NonOrderProductData;
    let rows = [];
 
    let autoId=0;
    temNonordata.forEach((row,i) => {

        const testIdFromModal = row.TestId;
        const matchingTestId = manyTableData.find(data => data.TestId === testIdFromModal);

        if (!matchingTestId) {
          autoId++
          let newRow={} ;
          newRow.TestId =row.TestId;
          newRow.TestProfileId =row.TestProfileId;
          newRow.TestAppointmentDate = null;
          newRow.TestName =row.TestName;
          newRow.UnitName =row.UnitName;
          newRow.Results =null;

          newRow.SKU=autoId;
          newRow.id=autoId;
          rows.push(newRow);
        
        }

    
  });

  manyTableData.forEach((row,i) => {
    autoId++;
    let newRow={} ; 
    newRow.TransactionItemId = row.TransactionItemId;
    newRow.TestId =row.TestId;
    newRow.TestProfileId =row.TestProfileId;
    newRow.TestAppointmentDate = row.TestAppointmentDate;
    newRow.TestName =row.TestName;
    newRow.UnitName =row.UnitName;
    newRow.Results =row.Results;
    newRow.SKU=autoId;
    newRow.id=autoId; 
    rows.push(newRow);

}); 

    setManyTableData(rows);   
    props.handleAdd(rows); 
    handleClose('Products');
  }; 

  const addTestAppointment = (NonOrderProductData) => {  
    console.log('Test Appointment list from modal : ', NonOrderProductData); 

    props.handleAddPatient(NonOrderProductData);
 
    let temNonordata=NonOrderProductData;
    let rows = [];
 
    let autoId=0;
    temNonordata.forEach((row,i) => {

        const testIdFromModal = row.TestId;
        const TestAppointmentIdFromModal = row.TestAppointmentId;
       /*  console.log('TestAppointmentIdFromModal: ', TestAppointmentIdFromModal); */
        const matchingTestId = manyTableData.find(data => data.TestId === testIdFromModal);

        if (!matchingTestId) {
          autoId++
          let newRow={} ;
          newRow.TestId =row.TestId;
          newRow.TestAppointmentId =row.TestAppointmentId;
          newRow.TestAppointmentDate =row.TransactionDate;
          newRow.TestName =row.TestName;
          newRow.UnitName =row.UnitName;
          newRow.Results =null;

          newRow.SKU=autoId;
          newRow.id=autoId;
          rows.push(newRow);
        
        }

    
  });

  manyTableData.forEach((row,i) => {
    autoId++;
    let newRow={} ; 
    newRow.TransactionItemId = row.TransactionItemId;
    newRow.TestId =row.TestId;
    newRow.TestAppointmentId =row.TestAppointmentId;
    newRow.TestAppointmentDate =row.TestAppointmentDate;
    newRow.TestName =row.TestName;
    newRow.UnitName =row.UnitName;
    newRow.Results =row.Results;
    newRow.SKU=autoId;
    newRow.id=autoId; 
    rows.push(newRow);

}); 

    setManyTableData(rows);   
    props.handleAdd(rows); 
    handleClose('TestAppointmentClose');
  }; 


  
  const addTestResult = (productSourceData) => {
    if (!productSourceData) {
      return;
    }

    // console.log("rows before pick product: ", manyTableData);
    // console.log("Product batch selected data: ", productBatchData);
    // console.log("Product batch selected currRowId: ", currRowId);

    let tempProductSourceData = productSourceData[0];
    console.log('tempProductSourceData: ', tempProductSourceData);
    let rows = [];

    // let autoId = Date.now(); // 0;

   


  
    // manyTableData.forEach((row, i) => {
    //   // autoId++;
    //   let newRow = {};

      

    //   if (row.TestId === currRowId) {
    //     // newRow.TestId = tempProductSourceData.TestId;
    //     newRow.Results = tempProductSourceData.TestResultName;
    //   } else {
    //     // newRow.TestId = row.TestId;
    //     newRow.Results = row.Results;
    //   }

    // newRow.ItemNo =row.ItemNo;
    // newRow.ItemCode =row.ItemCode;
    
    // newRow.ItemName =row.ItemName;
    // newRow.UnitPrice =row.UnitPrice; 
    // newRow.TransactionItemId = row.TransactionItemId;
    // newRow.OrderRemainingQty = row.OrderRemainingQty;
    // newRow.CurrentStockQty = row.CurrentStockQty;
    // newRow.Quantity =row.Quantity;
    // newRow.BatchNo = row.BatchNo;
    // newRow.ExpiryDate =row.ExpiryDate;
    // newRow.SKU=row.SKU;
    // newRow.id=row.id; 
    // newRow.LineTotal=row.Quantity*row.UnitPrice;
    // rows.push(newRow);
    // });


    manyTableData.forEach((row,i) => {
      // autoId++;
      let newRow={} ; 
      newRow.TransactionItemId = row.TransactionItemId;
      newRow.TestId =row.TestId;
      newRow.TestName =row.TestName;
      
      if (row.TestId === currRowId) {
        newRow.Results = tempProductSourceData.TestResultName;
      } else {
        newRow.Results =row.Results;
      }

      newRow.UnitName =row.UnitName;
     
      newRow.SKU=row.id;
      newRow.id=row.id; 
      rows.push(newRow);
  
  }); 

    // console.log("rows after link with product: ", rows);

    setManyTableData(rows);   
    props.handleAdd(rows); 
    handleClose('LabResultClose');
  };

  
  const addPatient = (PatientData) => {
    
    props.handleAddPatient(PatientData);
    handleClose("Contract");

    
  };


  
  const ReceiveDetailsColumns = [
    {
      title: "TransactionItemId", 
      field: "TransactionItemId", 
      visible: false 
    }, 
    { 
      title: "id", 
      field: "id", 
      visible: false 
    }, 
    { 
      title: t(DispensingLanguage[lan][menukey]['Sl#']),  
      width: 70, 
      formatter: "rownum", 
      hozAlign: "center", 
      headerHozAlign:"center", 
      headerSort:false
  },

    { 
      title: t(DispensingLanguage[lan][menukey]['Actions']), 
      field: 'custom', 
      headerSort:false, 
      headerHozAlign:"center", 
      hozAlign: 'center',
      width: 80,
     formatter: reactFormatter(<ActionButton 
     /* insertBatchInUpdatedDetailGridData={props.insertBatchInUpdatedDetailGridData} */ />) } ,
    
     {
      title: t(DispensingLanguage[lan][menukey]["Appointment Date"]),
      field: "TestAppointmentDate",
      width: 120,
      visible:false,
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        let date = value ? new Date(value) : null;
        if (!date || !isValid(date)) {
          return "";
        }
        return format(date, 'dd/MM/yyyy');
      },
    },

    { 
      title: t(DispensingLanguage[lan][menukey]['Test Name']), 
    field: "TestName",
    headerFilter:true,
  },
    { 
      title: t(DispensingLanguage[lan][menukey]['Test Result']), 
      field: "Results", 
      width: 600, 
      visible:false,
      headerFilter:true,
      cssClass: "tabluator-column-editable text-field-editable",
      editor: props.bStockUpdate == 0 ? cellFocusEditor: '',      
      // cellEdited: function (cell) {
      //   const curcellval = cell.getValue();
      //   const currow = cell.getRow();
      //   const rowdata = currow.getData(); 
      // }
    },     
    {
      title: "",
      headerSort: false,
      field: "custom",
      hozAlign: "center",
      width: 8,
      visible:false,
      formatter: reactFormatter(<ShowTestResultPopup />),
    },  
    { 
      title: t(DispensingLanguage[lan][menukey]['Test Unit']), 
      field: "UnitName",
      headerFilter:true,
    },
  ];
   
  
  function ShowTestResultPopup(propss) {
    const rowData = propss.cell._cell.row.data;
    // console.log('rowData: ', rowData);
    // TestId = 1 = SEROLOGIE VIH
    if ((props.bStockUpdate) || (rowData.TestId !== 1)) {
      return <></>;
    } else {
      
      return (
        <>
          <ViewList
            onClick={() => {
              setCurrRowId(rowData.TestId);
              handleClose("LabResultOpen");
            }}
          />
        </>
      );
    }
  }

 const onPostBtnClick = () => { 
  setbStockUpdate(true); 
   props.handlePost();

 }

  const onSaveUpdateBtnClick = () => { 
    if (props.isSubmitting) return;
    props.setUpdatedDetailsGridDataHandler(ReceiveDetailsRef.table.getData()); 
  //  props.handleUpdate();
  }

  const deleteReceiveInv = (data) => { 
    let newarray = manyTableData.filter(element => element !== data); 
    setManyTableData(newarray); 
    props.deleteReceiveInv(data); 
  };


  // const CopyBatch = () => {
    
  //   props.handleAdd(manyTableData); 
    
  // };

  

  

  function ActionButton (props) { 

    const rowData = props.cell._cell.row.data;  

    const cellValue = props.cell._cell.value || 'Edit | Show';
    if(bStockUpdate == 0)
    return (
      <>

        <DeleteOutline
          onClick={() => {
            if (!bStockUpdate) deleteReceiveInv(rowData);
          }}
        />

      </>
    );
    else  return (
      <>
         
      </>
    );
  }

  
  
  useEffect(() => {
    if(props.bFirst){
      setManyTableData(props.ManyTableData);
    }

    setbStockUpdate(props.bStockUpdate);
}, [props.ManyTableData,props.bStockUpdate]); //


useEffect(() => {
  if (ReceiveDetailsRef.table != null && timeStamp != '') {

    // console.log("Many table",ReceiveDetailsRef.table);
    // console.log("Many table 12222222222");

    ReceiveDetailsRef.table.scrollToRow(timeStamp, "center", true);
    ReceiveDetailsRef.table.selectRow(timeStamp);


  }
}, [newBatchRowAdded])

const handleReset = () => {
  setManyTableData([]);  
  props.handleReset();
};


/* const [TestToFacilityIdValue, setTestToFacilityIdValue] = useState({ id: '', name: "" });
 */
/* useEffect(() => {
  setTestToFacilityIdValue(IssueToList[IssueToList.findIndex(IssueTo_List => IssueTo_List.id == props.formData.TestToFacilityId)]);
}, [props.formData.TestToFacilityId]);
 */

/* const changeTestToFacilityIdValue = (val) => {

  setTestToFacilityIdValue(val);


  if (val != null) {
    props.formData.TestToFacilityId = val.id;
  } else {
    props.formData.TestToFacilityId = "";
  }

  props.handleChangeissuedToFacilityProps(val);

}; */


  return (
    <div className={classes.productPageTitle}>
    <div className="sw_makeStyles_tableContainer">
      <div className="d-flex justify-product mb-3">
        <Grid container>
        <Grid item xs={12} sm={12}>

        <div className="sw_page_heading">
            
            
            <div className="sw_heading_title">{DispensingLanguage[lan][menukey]['Test Appointment - Add/Edit']}</div>
            
            <div className="float-end sw_btn_control">

            {
            props.addProductForm ?
              <Grid item xs={12} className="mt-4 text-center">
               <div className="float-end sw_btn_control">
                <Button
                  className="me-2"
                  variant="contained"
                  color="gray"
                  type="reset"
                  onClick={() => handleReset()}
                >
                  {DispensingLanguage[lan][menukey]['Reset']}
                </Button>
                <Button
                  className="me-2"
                  variant="contained"
                  color="primary"
                  disabled={!!props.isSubmitting}
                  onClick={onSaveUpdateBtnClick}
                >
                  {DispensingLanguage[lan][menukey]['Save']}
                </Button>
                <Button
                  className="me-2"
                  variant="contained"
                  color="gray"
                  type="reset"
                  onClick={() => props.history.push("/test-appointment-entry")}
                >
                  {DispensingLanguage[lan][menukey]['Back to List']}
                </Button>
               </div>
              </Grid>
              :
              <Grid item xs={12} className="mt-2 text-center">
                <Button
                  disabled={!!props.bStockUpdate || !!props.isSubmitting}
                  className="me-2"
                  variant="contained"
                  color="primary"
                  onClick={onSaveUpdateBtnClick}
                   
                >
                 {DispensingLanguage[lan][menukey]['update']}
                </Button>
                {/* <Button 
                  disabled={!!props.bStockUpdate}
                  className="me-2"
                  variant="contained"
                  color="primary"
                  onClick={onPostBtnClick}
                >
                  {DispensingLanguage[lan][menukey]['Post']}
                </Button> */}
                <Button
                  className="me-2"
                  variant="contained"
                  color="gray"
                  type="reset"
                  onClick={() => props.history.push("/test-appointment-entry")}
                >
                 {DispensingLanguage[lan][menukey]['Back to List']}
                </Button>

                <Button
                variant="contained"
                color="primary"
                className="me-2 sw_icons"
                onClick={() => PrintMany()}
                >
                <i className="fas fa-print"></i>
                </Button>

                <Button
                variant="contained"
                color="primary"
                className="me-2 sw_icons"
                onClick={() => ExcelMany()}
                >
                <i className="far fa-file-excel"></i>
                </Button>

              </Grid>
          }

            </div>
         </div>   
        </Grid>
       </Grid>
      </div>

      <Grid container spacing={3} className="mb-3">
        <Grid item xs={2} sm={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
              <DatePicker
                disabled={!!props.bStockUpdate}
                //disableToolbar
                label={DispensingLanguage[lan][menukey]['Entry Date']}
                value={props.formData.TransactionDate||props.selectedDate}
                inputFormat="dd/MM/yyyy"
                onChange={(e) => props.handleRDateChange(e, "TransactionDate")}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    required
                    error={!!props.errorObject.TransactionDate}
                    helperText={props.errorObject.TransactionDate}
                    className={classes.fullWidth}
                    id="TransactionDate"
                    name="TransactionDate"
                    fullWidth
                    inputProps={{
                      ...params.inputProps,
                      value: params.inputProps?.value ?? "",
                    }}
                  />
                )}
              />
            </LocalizationProvider> 
        </Grid>

        <Grid item xs={2} sm={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
              <DatePicker
                disabled={!!props.bStockUpdate}
                //disableToolbar
                label={DispensingLanguage[lan][menukey]['Appointment Date']}
                value={props.formData.AppointmentDate||props.selectedDate}
                inputFormat="dd/MM/yyyy"
                onChange={(e) => props.handleRDateChange(e, "AppointmentDate")}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    required
                    error={!!props.errorObject.AppointmentDate}
                    helperText={props.errorObject.AppointmentDate}
                    className={classes.fullWidth}
                    id="AppointmentDate"
                    name="AppointmentDate"
                    fullWidth
                    inputProps={{
                      ...params.inputProps,
                      value: params.inputProps?.value ?? "",
                    }}
                  />
                )}
              />
            </LocalizationProvider> 
        </Grid>
        
        <Grid item xs={2} sm={2}>
          <TextField variant="standard"
              disabled={true/*bStockUpdate*/}
              error={!!props.errorObject.TransactionNo}
              helperText={props.errorObject.TransactionNo}
              required
            id="TransactionNo"
            name="TransactionNo"
            label={DispensingLanguage[lan][menukey]['Invoice No']} 
            // value={formData.FirstName || "Mahmudul"}
            value={(props.formData.TransactionNo ?? props.generatedInvoiceNo) ?? ""}
            fullWidth
            autoComplete="family-name"
            onChange={(e) => props.handleChange(e)}
          />
        </Grid>

        <Grid item xs={3} sm={3}>
          <FormControl variant="standard" className={classes.fullWidth}>
            <InputLabel id="demo-simple-select-helper-label">
            
              {DispensingLanguage[lan][menukey]["Test Profile Group"]} *
            </InputLabel>
            <Select
              error={!!props.errorObject.TestProfileGroupId}
              labelId="demo-simple-select-helper-label"
              id="TestProfileGroupId"
              name="TestProfileGroupId"
              value={props.formData.TestProfileGroupId ?? ""}
              fullWidth
              onChange={(e) => props.handleChange(e)}
              /* disabled={!!props.bStockUpdate} */
              disabled={!!( manyTableData.length>0? true:props.bStockUpdate)}
            label={`${DispensingLanguage[lan][menukey]["Test Profile Group"]} *`}>
            {TestProfileGroup.map((item, index) => {
                return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
              })}
            </Select>
            <FormHelperText error={!!props.errorObject.TestProfileGroupId}>
              {props.errorObject.TestProfileGroupId}
            </FormHelperText>
          </FormControl>
        </Grid>

          <Grid item xs={3} sm={3} className="sw_relative">
          <TextField variant="standard"
            disabled={true}
            error={!!props.errorObject.idNumber}
            helperText={props.errorObject.idNumber}
            required
            id="idNumber"
            name="idNumber"
            label={DispensingLanguage[lan][menukey]['Register#']} 
            value={props.formData.idNumber ?? ""}
            fullWidth
            autoComplete="family-name"
            onChange={(e) => props.handleChange(e)}
          />

            <Button
              disabled={!!props.bStockUpdate}
              className="pick_btn_place"
              variant="contained"
              color="gray"
              onClick={() => handleClose("ContractOpen")}
            >
              ...
            </Button>

            <PatientModal
              handleClose={handleClose}
              open={openContract}
              addPatient={addPatient}
              FacilityId={FacilityId} 
              {...props}
            />
        </Grid>

        <Grid item xs={4} sm={4}>
          <TextField variant="standard"
            // disabled={!!props.bStockUpdate}
            disabled={(props.bStockUpdate)?true:false}

            id="ContactNumber"
            name="ContactNumber"
            label={DispensingLanguage[lan][menukey]['Contact#']} 
            value={props.formData.ContactNumber ?? ""}
            fullWidth
            autoComplete="family-name"
            onChange={(e) => props.handleChange(e)}
          />
        </Grid>

        <Grid item xs={3} sm={3}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
          <DatePicker
            // disabled={props.formData.PatientId>0?true:false}
            disabled={(props.formData.PatientId>0 || props.bStockUpdate)?true:false}

            label={DispensingLanguage[lan][menukey]["DoB"]}
            value={props.formData.Dob || null}
            inputFormat="dd/MM/yyyy"
            onChange={(e) => props.handleRDateChange(e, "Dob")}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                required
                error={!!props.errorObject.Dob}
                helperText={props.errorObject.Dob}
                id="dob-date-picker-dialog"
                name="Dob"
                fullWidth
                inputProps={{
                  ...params.inputProps,
                  value: params.inputProps?.value ?? "",
                }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>

        <Grid item xs={2} sm={2}>
          <FormControl variant="standard" className={classes.fullWidth}>
            <InputLabel id="demo-simple-select-helper-label">
            
              {DispensingLanguage[lan][menukey]["Gender"]} *
            </InputLabel>
            <Select
              error={!!props.errorObject.GenderTypeId}
              disabled={(props.formData.PatientId>0 || props.bStockUpdate)?true:false}
          
              labelId="demo-simple-select-helper-label"
              id="GenderTypeId"
              name="GenderTypeId"
              value={props.formData.GenderTypeId ?? ""}
              fullWidth
              onChange={(e) => props.handleChange(e)}
              // disabled={!!props.bStockUpdate}
            label={`${DispensingLanguage[lan][menukey]["Gender"]} *`}>
            {Gender.map((item, index) => {
                return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
              })}
            </Select>
            <FormHelperText error={!!props.errorObject.GenderTypeId}>
              {props.errorObject.GenderTypeId}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xs={3} sm={3}>
          <FormControl variant="standard" className={classes.fullWidth}>
            <InputLabel id="demo-simple-select-helper-label">
            
              {DispensingLanguage[lan][menukey]["Prepared By"]} *
            </InputLabel>
            <Select
              error={!!props.errorObject.PreparedBy}
          
              labelId="demo-simple-select-helper-label"
              id="PreparedBy"
              name="PreparedBy"
              value={props.formData.PreparedBy ?? ""}
              fullWidth
              onChange={(e) => props.handleChange(e)}
              disabled={!!props.bStockUpdate}
            label={`${DispensingLanguage[lan][menukey]["Prepared By"]} *`}>
            {UsersListByFacility.map((item, index) => {
                return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
              })}
            </Select>
            <FormHelperText error={!!props.errorObject.PreparedBy}>
              {props.errorObject.PreparedBy}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xs={6} sm={6}>
          <TextField variant="standard"
            disabled={!!props.bStockUpdate}
            id="Remarks"
            name="Remarks"
            label={DispensingLanguage[lan][menukey]['Remarks']} 
            value={props.formData.Remarks ?? ""}
            fullWidth
            autoComplete="family-name"
            onChange={(e) => props.handleChange(e)}
          />
        </Grid>

        <Grid item xs={3} sm={3}>
          
          <TextField variant="standard" 
            id="FacilityId"
            name="FacilityId"
            label="FacilityId"  
            value={props.formData.FacilityId ?? ""}
            fullWidth
            hidden
            autoComplete="family-name" 
          />
          <TextField variant="standard" 
            id="TransactionId"
            name="TransactionId"
            label="TransactionId"  
            value={props.formData.TransactionId ?? ""}
            fullWidth
            hidden
            autoComplete="family-name" 
          />
        </Grid>  
      </Grid>

      <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <Card className="sw_card">
              <CardContent>
                <Grid container className="mb-2">
                  <Grid item xs={12} sm={12}>
                    <div className="float-end sw_btn_control">
                        <Button
                        /*  disabled={(props.formData.idNumber || props.formData.TestToFacilityId==0 || props.bStockUpdate)?true:false} */
                        disabled={( props.formData.TestProfileGroupId==0 || props.bStockUpdate)?true:false}
                        className="me-2"
                        variant="contained"
                        color="primary"
                        onClick={() => handleClose("ProductsOpen")}
                      >
                        {DispensingLanguage[lan][menukey]['SELECT TEST']}  
                      </Button>  
                    </div>
                    <LabTestAppointmentModal handleClose={handleClose} open={openTestAppointment} FacilityId={FacilityId} TestToFacilityId={props.formData.TestToFacilityId} addTestAppointment={addTestAppointment} {...props} />
                    <AppointmentEntryLabTestModal handleClose={handleClose} open={open} FacilityId={FacilityId} TestToFacilityId={props.formData.TestToFacilityId} TestProfileGroupId={props.formData.TestProfileGroupId} addProduct={addProduct} {...props} />
                    <LabTestResultModal handleClose={handleClose} open={openLabResult} addTestResult={addTestResult} TestId={currRowId}  {...props} />

                    
                  </Grid>
                </Grid> 
                  <ReactTabulator
                    onRef={(r) => { ReceiveDetailsRef.table = r.current; }}
                    columns={ReceiveDetailsColumns}
                    data={manyTableData}
                    height="500px"
                    layout={"fitColumns"}
                  />
                
              </CardContent>
            </Card>
          </Grid>
        </Grid>
    </div>
  </div>
  );
};

export default DispenserFormData;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
});
